/**
 * Quick Add to Cart – Variant Availability Check
 *
 * Watches for gw-quick-add-to-cart-form elements inside the
 * gw-customer-accounts shadow DOM. When variants are loaded into
 * the <select name="id">, fetches /products/{handle}.js and:
 *   - marks unavailable variants
 *   - swaps the ATC button label to "JOIN WAITLIST"
 *   - intercepts submission for unavailable variants → navigates to PDP
 */
(function () {
  'use strict';

  var WAITLIST_LABEL = 'JOIN WAITLIST';
  var productCache = {};   // handle → { availMap, productData }

  /* ── helpers ─────────────────────────────────────────────── */

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (product) {
        if (!product) return null;
        var availMap = {};
        product.variants.forEach(function (v) {
          availMap[String(v.id)] = v.available;
        });
        productCache[handle] = {
          availMap: availMap,
          productData: product
        };
        return productCache[handle];
      })
      .catch(function () {
        return null;
      });
  }

  function getHandle(formEl) {
    var card = formEl.closest('.gw-product-card');
    if (!card) return null;
    var link = card.querySelector('[data-product-link]');
    if (!link || !link.href) return null;
    var m = link.href.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function getAddToCartLabel(btn) {
    // Grab the original label from the button before we ever change it
    if (!btn._origLabel) {
      // textContent includes the loader text, so get only direct text nodes
      var text = '';
      btn.childNodes.forEach(function (n) {
        if (n.nodeType === 3) text += n.textContent;
      });
      btn._origLabel = text.trim() || 'Add to cart';
    }
    return btn._origLabel;
  }

  function setButtonState(formEl, available) {
    var btn = formEl.querySelector('button.gw-button--solid');
    if (!btn) return;

    // Preserve the loader span
    var loader = btn.querySelector('[data-loader]');
    var origLabel = getAddToCartLabel(btn);

    if (available) {
      // Clear and re-set
      btn.textContent = origLabel;
      if (loader) btn.appendChild(loader);
      btn.removeAttribute('data-waitlist');
    } else {
      btn.textContent = WAITLIST_LABEL;
      if (loader) btn.appendChild(loader);
      btn.setAttribute('data-waitlist', 'true');
    }
  }

  /* ── main processor ─────────────────────────────────────── */

  function processForm(formEl) {
    if (formEl.getAttribute('data-gw-avail-processed')) return;

    var select = formEl.querySelector('select[name="id"]');
    if (!select || select.options.length === 0) return;

    var handle = getHandle(formEl);
    if (!handle) return;

    formEl.setAttribute('data-gw-avail-processed', 'true');

    fetchProduct(handle).then(function (cached) {
      if (!cached) return;
      var availMap = cached.availMap;
      var productData = cached.productData;

      // Mark each option
      Array.from(select.options).forEach(function (opt) {
        if (!availMap[String(opt.value)]) {
          opt.setAttribute('data-unavailable', 'true');
        }
      });

      // Set initial button state
      setButtonState(formEl, !!availMap[String(select.value)]);

      // React to variant changes
      select.addEventListener('change', function () {
        setButtonState(formEl, !!availMap[String(select.value)]);
      });

      // Prevent cart submission for unavailable variants → trigger BIS
      formEl.addEventListener('submit', function (e) {
        var btn = formEl.querySelector('button.gw-button--solid');
        if (btn && btn.getAttribute('data-waitlist') === 'true') {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Build a temporary .BIS_trigger link in the light DOM
          var selectedVariantId = select.value;
          var trigger = document.createElement('a');
          trigger.href = '#';
          trigger.className = 'BIS_trigger';
          trigger.setAttribute(
            'data-product-data',
            JSON.stringify(productData)
          );
          trigger.setAttribute('data-variant-id', selectedVariantId);
          trigger.style.display = 'none';
          document.body.appendChild(trigger);
          trigger.click();

          // Clean up after a short delay so Klaviyo can process
          setTimeout(function () {
            if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
          }, 500);
        }
      });
    });
  }

  /* ── observer / scanner ──────────────────────────────────── */

  function scanRoot(root) {
    if (!root) return;
    var forms = root.querySelectorAll(
      'gw-quick-add-to-cart-form form[data-quick-add-to-cart-form]'
    );
    forms.forEach(processForm);
  }

  function startObserving(root) {
    scanRoot(root);
    var obs = new MutationObserver(function () {
      scanRoot(root);
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function init() {
    var gwEl = document.querySelector('gw-customer-accounts');
    if (!gwEl) return;

    // The component uses open shadow DOM
    if (gwEl.shadowRoot) {
      startObserving(gwEl.shadowRoot);
      return;
    }

    // Poll for shadow root creation (external script loads async)
    var attempts = 0;
    var poll = setInterval(function () {
      if (gwEl.shadowRoot) {
        clearInterval(poll);
        startObserving(gwEl.shadowRoot);
      } else if (++attempts > 150) {
        // 30 seconds max wait, then try light DOM as fallback
        clearInterval(poll);
        startObserving(gwEl);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
